// @flow
import React from 'react';
import { useFormikContext } from 'formik';
import { TABLEFLOW_RESOURCES_GRID_FIELDNAMES } from '@streaming-projects/orgs/enums';
import { getDropdownOptions } from '@components/stream-governance/utils';
import { SelectField } from '@src/formik-utils/FormFields';

import { TABLEFLOW_RESOURCE_INPUTS_DETAILS_CONFIG_MAP } from './tableflow-resource-inputs-config';

export const SPTableFlowClusterResourceNameContainer = ({
  disabled,
  disableOnFormErrors = null,
  fluid = null,
  availableClusterResources = [],
}) => {
  const { values } = useFormikContext();
  const tableFlowClusterResourceNameConfig = TABLEFLOW_RESOURCE_INPUTS_DETAILS_CONFIG_MAP.get(
    TABLEFLOW_RESOURCES_GRID_FIELDNAMES.CLUSTER_RESOURCE_ID
  );

  const dataUniverse = availableClusterResources.map(({ name, id }) => ({
    [TABLEFLOW_RESOURCES_GRID_FIELDNAMES.CLUSTER_RESOURCE_NAME]: name,
    [TABLEFLOW_RESOURCES_GRID_FIELDNAMES.CLUSTER_RESOURCE_ID]: id,
  }));

  const tableFlowClusterResourceNameOptions = getDropdownOptions(
    dataUniverse,
    values,
    tableFlowClusterResourceNameConfig,
    false,
    true,
    false,
    false,
    [],
    true // sorting values based on displayName
  );
  return (
    <SelectField
      disableOnFormErrors={disableOnFormErrors}
      disabled={disabled}
      fieldDisplayName={tableFlowClusterResourceNameConfig.displayName}
      fieldName={tableFlowClusterResourceNameConfig.backendFieldName}
      fluid={fluid}
      options={tableFlowClusterResourceNameOptions}
    />
  );
};
